import type { NextPage } from 'next'
import { getCMSContent, getCMSFullList } from '@/client/utils'
import { BlogsLandingPage } from '@/client/modules/Blogs/BlogsLandingPage'

const BlogsPage: NextPage<any> = (props) => <BlogsLandingPage {...props} />

export async function getServerSideProps({ defaultLocale, locale, query }) {
  const currentPageQuery = query && query.page ? query : { page: 1, search: '' }
  const data = (await getCMSContent(defaultLocale, locale, 'BLOGS_LANDING_PAGE')) ?? undefined
  const blogLists = (await getCMSFullList(locale, 'blog', '', currentPageQuery, currentPageQuery.search)) ?? undefined
  if (!data?.content) return { notFound: true }
  return {
    props: { blogLists: blogLists['acfResponse'], ...data, meta: blogLists['meta'] }
  }
}

export default BlogsPage
